import React from "react";

function Spinner() {
  return (
    <div className="spinner-wrapper">
      <div className="spinner"></div>
      <p>Cargando...</p>
    </div>
  );
};

export  {Spinner};
